import { render } from "./CrmApplications.vue?vue&type=template&id=dcd885dc"
import script from "./CrmApplications.vue?vue&type=script&lang=js"
export * from "./CrmApplications.vue?vue&type=script&lang=js"

import "./CrmApplications.vue?vue&type=style&index=0&id=dcd885dc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__